import GameSignals from '@/signals/GameSignals'
import { GameStatesEnum } from '@/states/GameStatesEnum'
import { BeforeLoadingState } from '@/states/loadings/BeforeLoadingState'
import { DisplaySplashScreenState } from '@/states/loadings/DisplaySplashScreenState'
import { GetInitResponseState } from '@/states/loadings/GetInitResponseState'
import { InitState } from '@/states/loadings/InitState'
import { LoadingState } from '@/states/loadings/LoadingState'
import { RestoreState } from '@/states/loadings/RestoreState'
import { StartSpinState } from '@/states/reels_spinning/StartSpinState'
import { StopSpinState } from '@/states/reels_spinning/StopSpinState'
import { FinalState } from '@/states/round/FinalState'
import { IdleState } from '@/states/round/IdleState'
import { StartRoundState } from '@/states/round/StartRoundState'
import { StopRoundState } from '@/states/round/StopRoundState'
import { StateMachine } from '@stateMachine/StateMachine'
import StateSignals from '@stateMachine/StateSignals'
import { GetSpinResponseState } from '@/states/reels_spinning/GetSpinResponseState'
import { HoldAndWinActivateState } from '@/states/holdandwin/HoldAndWinActivateState'
import { HoldAndWinIntroState } from '@/states/holdandwin/HoldAndWinIntroState'

export class GameStateMachine extends StateMachine {
    public init() {
        // game loading states
        this.addState(BeforeLoadingState, GameStatesEnum.BEFORE_LOADING_STATE)
        this.addState(GetInitResponseState, GameStatesEnum.GET_INIT_RESPONSE_STATE)
        this.addState(LoadingState, GameStatesEnum.LOADING_STATE)
        this.addState(InitState, GameStatesEnum.INIT_STATE)
        this.addState(DisplaySplashScreenState, GameStatesEnum.DISPLAY_SPLASH_SCREEN_STATE)

        // round/features logic states
        this.addState(RestoreState, GameStatesEnum.RESTORE_STATE)
        this.addState(IdleState, GameStatesEnum.IDLE_STATE)
        this.addState(StartRoundState, GameStatesEnum.START_ROUND_STATE)
        this.addState(FinalState, GameStatesEnum.FINAL_STATE)
        this.addState(StopRoundState, GameStatesEnum.STOP_ROUND_STATE)

        // reels spinning states
        this.addState(StartSpinState, GameStatesEnum.START_SPIN_STATE)
        this.addState(GetSpinResponseState, GameStatesEnum.GET_SPIN_RESPONSE_STATE)
        this.addState(StopSpinState, GameStatesEnum.STOP_SPIN_STATE)
        this.addState(HoldAndWinActivateState, GameStatesEnum.HOLD_AND_WIN_ACTIVATE_STATE)
        this.addState(HoldAndWinIntroState, GameStatesEnum.HOLD_AND_WIN_INTRO_STATE)

        // Insufficient-balance (and other) popups emit gamePause while still mid-round.
        // Nested pause → IDLE cleans up GetSpinResponseState before it can unlock the panel,
        // leaving the spin button stuck in stop / inactive. End the round for the panel first.
        // Only during gameplay round states — not loading / splash (casinoError can fire on load).
        const midRoundStates = new Set<string>([
            GameStatesEnum.START_ROUND_STATE,
            GameStatesEnum.START_SPIN_STATE,
            GameStatesEnum.GET_SPIN_RESPONSE_STATE,
            GameStatesEnum.STOP_SPIN_STATE,
            GameStatesEnum.FINAL_STATE,
            GameStatesEnum.STOP_ROUND_STATE,
            GameStatesEnum.HOLD_AND_WIN_ACTIVATE_STATE,
            GameStatesEnum.HOLD_AND_WIN_INTRO_STATE,
        ])
        GameSignals.gamePause.connect(() => {
            if (midRoundStates.has(this._currentStateName)) {
                this._model.isBuyBonusPending = false
                this._model.buyBonusPickPosition = 0
                this._model.bonusBuyBet = null
                GameSignals.roundStop.emit()
                GameSignals.unLockGamePanel.emit()
            }
            this.setState(GameStatesEnum.IDLE_STATE)
        })
    }

    public applyState(id: string) {
        console.log('STATE CHANGED:', id)
        StateSignals.stateChanged.emit(id)

        super.applyState(id)
    }
}
